function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import Video from '../../Video';
import MediaFrame from '../../MediaFrame';
import VisibilitySensor from '../../VisibilitySensor';
/**
 * :lock: **PRIVATE** :lock:
 *
 * The SmartVideo component is an internal component used by the Media component.
 * Do not use SmartVideo directly.
 *
 * SmartVideo will only load images when they are just about to be shown on screen.
 * For supported images a progressive loading treatment will be applied
 *
 * ## Composed of
 * - [MediaFrame](../../MediaFrame/README.md)
 * - [VisibilitySensor](../../VisibilitySensor/README.md)
 * - [Video](../../Video/README.md)
 *
 * ## Related Components
 * - [Media](../Media/README.md)
 *
 * ## Usages
 *
 * See `Media` component usage
 *
 * ## Props
 *
 * See `Video` for additional props
 */

var SmartVideo = /*#__PURE__*/function (_PureComponent) {
  _inherits(SmartVideo, _PureComponent);

  var _super = _createSuper(SmartVideo);

  function SmartVideo(props) {
    var _this;

    _classCallCheck(this, SmartVideo);

    _this = _super.call(this, props);
    _this._ref = /*#__PURE__*/createRef();
    return _this;
  }

  _createClass(SmartVideo, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var videoProps = this.props;

      var _render = videoProps.render,
          width = videoProps.width,
          height = videoProps.height,
          aspectRatio = videoProps.aspectRatio,
          fit = videoProps.fit,
          videoPropsFiltered = _objectWithoutProperties(videoProps, ["render", "width", "height", "aspectRatio", "fit"]);

      return /*#__PURE__*/React.createElement(VisibilitySensor, {
        intersectionThreshold: 0.1,
        element: this._ref
      }, function (_ref) {
        var isVisible = _ref.isVisible;

        if (!_this2.wasSeenOnce && !isVisible) {
          return /*#__PURE__*/React.createElement(MediaFrame, {
            ref: _this2._ref,
            width: width,
            height: height,
            aspectRatio: aspectRatio,
            fit: fit
          });
        }

        if (isVisible && !_this2.wasSeenOnce) {
          _this2.wasSeenOnce = true;
        }

        return /*#__PURE__*/React.createElement(Video, _extends({
          ref: _this2._ref,
          render: function render(player) {
            if (!isVisible) player.pause();

            if (typeof _render === 'function') {
              _render(player);
            }
          }
        }, videoPropsFiltered, {
          width: width,
          height: height,
          aspectRatio: aspectRatio,
          fit: fit
        }));
      });
    }
  }]);

  return SmartVideo;
}(PureComponent);

SmartVideo.defaultProps = {
  className: '',
  width: '100%',
  height: undefined,
  aspectRatio: '16:9',
  fit: 'cover'
};
SmartVideo.propTypes = {
  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Sets the width of the video to display
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Sets the height of the video to display
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * How to fit the image when aspect ratios are mismatched
   * values generally follow the `background-size` css property
   * [MDN Dos on background-size](https://developer.mozilla.org/en-US/docs/Web/CSS/background-size)
   */
  fit: PropTypes.oneOf(['cover', 'contain', 'fill']),

  /**
   * Aspect ratio to restrict the video to. Aspect ratios are defined in
   * the base styles package.
   */
  aspectRatio: PropTypes.oneOf([undefined, '1:1', '4:3', '16:9', '3:2', '2:3', '3:4'])
};
export default SmartVideo;